import { render, staticRenderFns } from "./title-layer.vue?vue&type=template&id=64193466&"
import script from "./title-layer.vue?vue&type=script&lang=js&"
export * from "./title-layer.vue?vue&type=script&lang=js&"
import style0 from "./title-layer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports